import React from "react";
import { Panel } from "../../components/ui/dashboard";

const ManageLoads: React.FC = () => {
  return (
    <div className="p-4 md:p-6">
      <Panel title="Manage Consignments" subtitle="Assign drivers, vehicles, and update status">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <select className="border rounded-lg px-3 py-2 text-sm">
            <option>Consignment: TT-2026-00190</option>
          </select>
          <select className="border rounded-lg px-3 py-2 text-sm">
            <option>Assign Driver: Ravi Kumar</option>
          </select>
          <select className="border rounded-lg px-3 py-2 text-sm">
            <option>Assign Vehicle: MH12AB4321</option>
          </select>
          <select className="border rounded-lg px-3 py-2 text-sm">
            <option>Status: booked</option>
            <option>in_transit</option>
            <option>delivered</option>
          </select>
        </div>
        <div className="mt-4 flex justify-end">
          <button className="px-3 py-2 rounded-lg text-sm bg-indigo-600 text-white">Save Assignment</button>
        </div>
      </Panel>
    </div>
  );
};

export default ManageLoads;